/**
 * SeasonalAdjustmentsPanel
 * Ajustes sazonais sugeridos com aplicação em lote.
 */

import React, { useState } from 'react'
import { CalendarRange, Loader2, CheckCircle2 } from 'lucide-react'
import './SeasonalAdjustmentsPanel.css'

function SeasonalAdjustmentsPanel({
  data,
  loading = false,
  applying = false,
  onApply,
  onApplyAll
}) {
  const [selected, setSelected] = useState([])

  const suggestions = data?.suggestions || []
  const monthlyIndices = data?.monthlyIndices || []

  const toggle = (code) => {
    setSelected((prev) =>
      prev.includes(code) ? prev.filter((c) => c !== code) : [...prev, code]
    )
  }

  const toggleAll = () => {
    if (selected.length === suggestions.length) {
      setSelected([])
    } else {
      setSelected(suggestions.map((s) => s.productCode))
    }
  }

  if (loading) {
    return (
      <div className="seasonal-adjustments seasonal-adjustments--loading">
        <Loader2 size={20} className="spinning" />
        <span>Carregando ajustes sazonais...</span>
      </div>
    )
  }

  if (!data?.brand) {
    return (
      <div className="seasonal-adjustments seasonal-adjustments--empty">
        <p>Selecione uma marca para ver ajustes sazonais sugeridos</p>
      </div>
    )
  }

  return (
    <div className="seasonal-adjustments">
      <div className="seasonal-adjustments-header">
        <div>
          <h3>
            <CalendarRange size={16} />
            Ajustes Sazonais
          </h3>
          <p>
            Índice do mês atual: <strong>{data.currentMonthIndex || 1}</strong>
            {data.peakMonth && (
              <> · Pico histórico: <strong>{data.peakMonth.label} ({data.peakMonth.index})</strong></>
            )}
          </p>
        </div>
        {suggestions.length > 0 && (
          <button
            type="button"
            className="seasonal-adjustments-apply-btn"
            disabled={applying}
            onClick={() => onApplyAll?.()}
          >
            {applying ? <Loader2 size={14} className="spinning" /> : <CheckCircle2 size={14} />}
            Aplicar todos ({suggestions.length})
          </button>
        )}
      </div>

      {monthlyIndices.length > 0 && (
        <div className="seasonal-adjustments-indices">
          {monthlyIndices.map((m) => (
            <span
              key={m.month}
              className={`seasonal-adjustments-index${m.month === data.currentMonth ? ' is-current' : ''}${m.index >= 1.2 ? ' is-high' : ''}`}
            >
              {m.label}: {m.index}
            </span>
          ))}
        </div>
      )}

      {data.message && suggestions.length === 0 && (
        <p className="seasonal-adjustments-message">{data.message}</p>
      )}

      {suggestions.length > 0 && (
        <>
          <div className="seasonal-adjustments-toolbar">
            <button type="button" className="seasonal-adjustments-link" onClick={toggleAll}>
              {selected.length === suggestions.length ? 'Desmarcar todos' : 'Selecionar todos'}
            </button>
            {selected.length > 0 && (
              <button
                type="button"
                className="seasonal-adjustments-apply-selected"
                disabled={applying}
                onClick={() => onApply?.(selected)}
              >
                Aplicar selecionados ({selected.length})
              </button>
            )}
          </div>

          <div className="seasonal-adjustments-list">
            {suggestions.map((item) => (
              <label key={item.productCode} className="seasonal-adjustments-item">
                <input
                  type="checkbox"
                  checked={selected.includes(item.productCode)}
                  onChange={() => toggle(item.productCode)}
                />
                <div className="seasonal-adjustments-item-body">
                  <strong>{item.productCode}</strong>
                  <span>{item.productName || '—'}</span>
                  <span className="seasonal-adjustments-item-qty">
                    {item.baseSuggested} → <em>{item.seasonalSuggested}</em> (+{item.adjustmentPercent}%)
                  </span>
                </div>
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  )
}

export default SeasonalAdjustmentsPanel
